import React, { useEffect, useState } from "react";
import { API_ENDPOINTS } from "../../../api/endpoints";

function DetalleCarga({ id }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async (id) => {
    const apiCreateServicesGhostAPI = API_ENDPOINTS.interna.CreateServicesGhostAPI(id);

    try {
      const response = await fetch(apiCreateServicesGhostAPI);
      if (!response.ok) throw new Error(`Error en la API: ${response.status}`);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error al obtener los datos:", error);
      return null;
    }
  };

  useEffect(() => {
    const loadData = async () => {
      const apiData = await fetchData(id);
      if (apiData && apiData.ExcelCarga) {
        const parsedData = JSON.parse(apiData.ExcelCarga).data;
        setData(parsedData);
      }
      setLoading(false);
    };
    loadData();
  }, [id]);

  const groupBy = (array, key) =>
    array.reduce((result, currentValue) => {
      (result[currentValue[key]] = result[currentValue[key]] || []).push(currentValue);
      return result;
    }, {});

  const formatCLP = (value) =>
    Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
      minimumFractionDigits: 0,
    }).format(value || 0);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "50vh" }}>
        <h1>
          Cargando
          <p>
            <svg id="page-preload" viewBox="25 25 50 50">
              <circle r="20" cy="50" cx="50"></circle>
            </svg>
          </p>
        </h1>
      </div>
    );
  }

  const groupedData = groupBy(data, "Grupo");

  return (
    <div className="pt-3">
      <div className="card">
        <div className="card-body">
          <table className="table table-striped table-hover small">
            <thead>
              <tr>
                <th>Vale</th>
                <th>Movil</th>
                <th>Tipo</th>
                <th>Fecha</th>
                <th>Origen</th>
                <th>Destino</th>
                <th>KM</th>
                <th>Min.</th>
                <th>TAG</th>
                <th>Peaje</th>
                <th>Est.</th>
                <th>
                  <strong>Total Serv.</strong>
                </th>
              </tr>
            </thead>

            <tbody>
              {data.map((entry, index) => {
                const isVan = entry.TipoMovil?.toUpperCase().trim() === "VAN";

                // Tarifas según tipo de vehículo
                const tagRate = 800;
                const minRate = isVan ? 220 : 170;
                const kmRate = isVan ? 1100 : 850;
                const BBandera = 2200;

                // Parseo de números
                const KM = Number(entry.KMRecorrido) || 0;
                const Min = Number(entry.MinRecorrido) || 0;
                const TAGCantidad = Number(entry.CantTAG) || 0;
                const TotalPeaje = Number(entry.TotalPeaje) || 0;
                const Estacionamiento = Number(entry.TotalEstacionamineto) || 0;

                // Cálculos
                const TAG = TAGCantidad * tagRate;
                const PECosto = TotalPeaje + Estacionamiento;
                const MinExtra = Min * minRate;
                const KMCosto = KM * kmRate;
                const TotalServicio = TAG + PECosto + MinExtra + KMCosto + BBandera;

                return (
                  <tr key={index}>
                    <td>{entry.TipoVale}</td>
                    <td>{entry.NMovil}</td>
                    <td>{entry.TipoMovil}</td>
                    <td style={{ whiteSpace: "nowrap", width: "1%" }}>{entry.Fecha}</td>
                    <td>{entry.Origen}</td>
                    <td>{entry.Destino}</td>
                    <td>{formatCLP(KMCosto)}</td>
                    <td>{formatCLP(MinExtra)}</td>
                    <td>{formatCLP(TAG)}</td>
                    <td>{formatCLP(TotalPeaje)}</td>
                    <td>{formatCLP(Estacionamiento)}</td>
                    <td>
                      <strong>{formatCLP(TotalServicio)}</strong>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default DetalleCarga;
